exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".capital-page[data-v-2c2157ff]{overflow:visible}.panel-heading h4[data-v-2c2157ff]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-2c2157ff]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-2c2157ff]{margin-right:-20px;padding-right:10px}.capital-page__panel-body[data-v-2c2157ff],.capital-page__toolbar[data-v-2c2157ff]{overflow:visible}[dir] .capital-page__toolbar[data-v-2c2157ff]{padding-top:12px;padding-bottom:12px}.capital-page .table th[data-v-2c2157ff]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c2157ff","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/capital/CapitalPage.vue
// module id = 1206
// module chunks = 0